import { getHeaders } from './common';
import { generateRandomString } from '../helpers/header';
import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'

export const fetchPolicyGroups = async (orgId) => {
  try {
    if (!orgId) return { success: false, error: "Organization ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/policy_by_org?orgid=${orgId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      const activeGroups = data.filter(policy => policy.status === "Active");
      return { success: true, data: activeGroups };
    } else {
      console.error("Failed to fetch policy groups.");
      return { success: false, error: "Failed to fetch policy groups" };
    }
  } catch (error) {
    console.error("Error fetching policy groups:", error);
    return { success: false, error: error.message };
  }
};


export const fetchAnnouncements = async (orgId) => {
  try {
    if (!orgId) return { success: false, error: "Organization ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/get_announcement_by_org?id=${orgId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch announcements.");
      return { success: false, error: "Failed to fetch announcements" };
    }
  } catch (error) {
    console.error("Error fetching announcements:", error);
    return { success: false, error: error.message };
  }
};


export const deleteAnnouncement = async (announcementId) => {
  try {
    if (!announcementId) return { success: false, error: "Announcement ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/delete_announcement?Id=${announcementId}`,
      {
        method: 'DELETE',
        headers: getHeaders(),
        credentials: 'include',
      }
    );

    if (response.ok) {
      return { success: true, message: "Announcement deleted successfully" };
    } else {
      console.error("Failed to delete announcement.");
      return { success: false, error: "Failed to delete announcement" };
    }
  } catch (error) {
    console.error("Error deleting announcement:", error);
    return { success: false, error: error.message };
  }
};

export const saveAnnouncement = async (announcement, isUpdate) => {
    if (!announcement) return { success: false, error: "Announcement data is required" };

    const apiUrl = isUpdate
        ? `${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/update_announcement`
        : `${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/create_announcement`;

    return apiPost({ endpoint: apiUrl, body: announcement, successMessage: isUpdate ? "Announcement updated successfully" : "Announcement created successfully", errorMessage: "Error saving announcement" })
};

export const uploadAnnouncementImage = async (announcementId, file) => {
  try {
    if (!announcementId || !file) {
      return { success: false, error: "Missing required parameters for image upload" };
    }

    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(
      `${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/upload_announcement_image?Id=${announcementId}`,
      {
        method: 'POST',
        headers: {
          'portalscope': 'b3NMWOVzfdRUjrW',
          'validatereq': generateRandomString(30)
        },
        body: formData,
        credentials: 'include',
      }
    );

    if (response.ok) {
      return { success: true, message: "Image uploaded successfully" };
    } else {
      console.error(`Failed to upload image: ${response.status}`);
      return { success: false, error: "Failed to upload image" };
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    return { success: false, error: error.message };
  }
};


export const deleteAnnouncementImage = async (announcementId, wallpaperId) => {
  try {
    if (!announcementId || !wallpaperId) {
      return { success: false, error: "Missing required parameters for image deletion" };
    }

    const url = new URL(`${process.env.REACT_APP_ANNOUNCEMENT_API_URL}/delete_announcement_image`);
    url.searchParams.append('Id', announcementId);
    url.searchParams.append('wallpaper', wallpaperId);

    const response = await fetch(
      url.toString(),
      {
        method: 'DELETE',
        headers: getHeaders(),
        credentials: 'include',
      }
    );

    if (response.ok) {
      return { success: true, message: "Image deleted successfully" };
    } else {
      const errorData = await response.json();
      console.error("Error deleting image:", errorData);
      return { success: false, error: errorData.title || "Failed to delete image" };
    }
  } catch (error) {
    console.error("Error deleting image:", error);
    return { success: false, error: error.message };
  }
};

